/*
 * Copyright © 2017 TEKTELIC Communications Inc.
 */
import './activity-log.scss';

import activityLogState from './activity-log-state.tpl.html';

const MAX_NUM_OF_LOGS_TO_STORE = 1000;

/*@ngInject*/
export default function ActivityLogController($scope, $rootScope, $mdMedia, $log, $translate, $document, $mdDialog, $filter, $timeout, types, userService, activityLogService, importExport) {
    var vm = this;
    let reloadDebounceTimer;

    vm.$onInit = function () {
        vm.types = types;
        vm.allActivityLogs = [];
        vm.totalElements = 0;
        vm.activityLogs = [];
        vm.rowsCount = 0;
        vm.query = {
            order: '-ts',
            limit: 15,
            page: 1,
        };
        vm.limitOptions = [15, 30, 45];
        vm.filter = {};
        vm.exportProgressPercent = 0;

        vm.config = {
            timewindow: {
                fixedTimewindow: {
                    minStartDateMs: Date.now() - 24 * 60 * 60 * 1000 * 365 * 3 // 3 years
                }
            },
            showColumns: {},
            showFilters: {}
        }

        vm.reload = reload;
        vm.reloadFromFirstPage = reloadFromFirstPage;
        vm.showStateDetails = showStateDetails;
        vm.checkState = checkState;

        vm.exportActivityLog = exportActivityLog;
        vm.cancelExporting = cancelExporting;

        vm.loading = function () {
            return $rootScope.loading;
        };

        vm.onPaginate = function () {
            reload();
        };

        vm.onReorder = function () {
            reload();
        };

        getTableConfig();
        resetFilters();
        resetExporting();
        reload();
    };

    $scope.$watch("vm.filter.timewindow", function (newVal, prevVal) {
        if (newVal && !angular.equals(newVal, prevVal)) {
            reloadFromFirstPage();
        }
    }, true);

    $scope.$watch("vm.filter.entityTypes", function (newVal, prevVal) {
        if (newVal && !angular.equals(newVal, prevVal)) {
            reloadWithDebounce();
        }
    });

    $scope.$watch("vm.filter.activityTypes", function (newVal, prevVal) {
        if (newVal && !angular.equals(newVal, prevVal)) {
            reloadWithDebounce();
        }
    });

    $scope.$watch("vm.exportProgressPercent", function (newVal) {
        if (newVal === 100) {
            $timeout(function () {
                resetExporting();
            }, 200);
        }
    });

    $scope.$watch(function () {
        return $mdMedia('gt-md');
    }, function (isGtMd) {
        vm.isGtMd = isGtMd;
        if (vm.isGtMd) {
            vm.limitOptions = [15, 30, 45];
        } else {
            vm.limitOptions = null;
        }
    });

    function getActionTypes(scope) {
        return types.userActivityLogEntityActionsMap.reduce(function (actionTypes, entity) {
            if (vm.userActivityLogEntities.includes(entity.name)) {
                for (let [key, action] of Object.entries(entity.actions)) {
                    if (!action.scope || action.scope.includes(scope)) {
                        actionTypes[key] = action.value;
                    }
                }
            }
            return actionTypes;
        }, { ...types.userActivityLogBasicActions })
    }

    function getTableConfig() {
        var currentUser = userService.getCurrentUser();
        var authority = currentUser.authority;
        var scope = types.authority[authority].scope;

        switch (scope) {
            case types.scope.system:
                vm.userActivityLogEntities = types.systemActivityLogEntities;
                vm.config.showFilters.provider = true;
                vm.config.showColumns.provider = true;
                break;
            case types.scope.provider:
                vm.userActivityLogEntities = types.providerActivityLogEntities;
                vm.config.showFilters.customer = true;
                vm.config.showColumns.provider = true;
                vm.config.showColumns.customer = true;
                break;
            case types.scope.customer:
                vm.userActivityLogEntities = types.customerActivityLogEntities;
                vm.config.showColumns.customer = true;
                break;
        }
        vm.userActivityLogActionTypes = getActionTypes(scope);
    }

    function getSortOrder() {
        var sortField = vm.query.order;
        var sortOrder = types.entityTable.sortOrder.asc.value;
        if (sortField[0] === '-') {
            sortOrder = types.entityTable.sortOrder.desc.value;
            sortField = sortField.substring(1);
        }
        return [sortOrder, sortField];
    }

    function getTimeFrame() {
        var startTs, endTs;
        if (vm.filter.timewindow.history.timewindowMs) {
            var currentTime = (new Date).getTime();
            startTs = currentTime - vm.filter.timewindow.history.timewindowMs;
            endTs = currentTime;
        } else {
            startTs = vm.filter.timewindow.history.fixedTimewindow.startTimeMs;
            endTs = vm.filter.timewindow.history.fixedTimewindow.endTimeMs;
        }
        return [startTs, endTs];
    }

    function loadActivityLogs(limit, page, startTs, endTs, sortOrder, sortField, totalElementsFlag = false) {
        return activityLogService.getUserActivityLog(vm.filter.providerTitle, vm.filter.customerTitle, vm.filter.entityTypes, vm.filter.entityId,
            vm.filter.entityEUI, vm.filter.entityName, vm.filter.userEmail, vm.filter.userIpAddress, vm.filter.activityTypes, vm.filter.description,
            startTs, endTs, limit, page, sortField, sortOrder, totalElementsFlag)
    }

    function getAllUserActivityLogs() {
        vm.exportInProgress = true;
        let totalElements = 0;
        let totalPages = 0;
        let allUserActivityLogs = [];
        let [startTs, endTs] = getTimeFrame();
        let [sortOrder, sortField] = getSortOrder();
        const getPaginatedUserActivityLog = (page = 0) => {
            let isFirstPage = page === 0 ? true : false;
            return loadActivityLogs(MAX_NUM_OF_LOGS_TO_STORE, page, startTs, endTs, sortOrder, sortField, isFirstPage).then(
                (data) => {
                    if (data) {
                        if (isFirstPage) {
                            totalElements = data.totalElements;
                            totalPages = Math.ceil(totalElements / MAX_NUM_OF_LOGS_TO_STORE);
                        }
                        page++;
                        allUserActivityLogs = [...allUserActivityLogs, ...data.data];
                        vm.exportProgressPercent = Math.ceil(page / totalPages * 100);
                        if (page < totalPages) {
                            return getPaginatedUserActivityLog(page);
                        } else {
                            return allUserActivityLogs;
                        }
                    }
                }, () => {
                    resetExporting();
                });
        }
        return getPaginatedUserActivityLog();  
    }

    function resetExporting() {
        vm.exportProgressPercent = 0;
        vm.exportInProgress = false;
    }

    function cancelExporting(){
        activityLogService.cancelFetchingActivityLog();
        resetExporting();
    }

    function exportActivityLog() {
        const columnsOrder = ['ts', 'userEmail', 'userIpAddress', 'providerTitle', 'customerTitle', 'activity', 'entityType',
            'entityMetaId', 'entityId', 'entityMetaName', 'previousState', 'newState', 'description'];

        getAllUserActivityLogs()
            .then((logs) => {
                if (logs) {
                const csvData = logs.reduce((acc, stateObject) => {
                    const row = [];
                    columnsOrder.forEach(column => {
                        switch (column) {
                            case 'ts':
                                row.push($filter('date')(new Date(stateObject[column]), 'yyyy-MM-dd HH:mm:ss'));
                                break;
                            default:
                                row.push(stateObject[column]);
                                break;
                        }
                    });
                    acc += row.join(';') + '\n';
                    return acc;
                }, '');
                var currentDate = $filter('date')((new Date).getTime(), 'yyyy-MM-dd');
                importExport.downloadFile(columnsOrder.join(';') + '\n' + csvData, currentDate + '_user-activity-log', types.fileType.CSV);
                }
            });
    }

    function resetFilters() {
        vm.filter = {
            timewindow: {
                history: {
                    timewindowMs: 24 * 60 * 60 * 1000 // 1 day
                }
            },
            providerTitle: '',
            customerTitle: '',
            entityTypes: [],
            entityId: '',
            entityEUI: '',
            entityName: '',
            userEmail: '',
            userIpAddress: '',
            activityTypes: [],
            description: ''
        };
    }

    function reloadFromFirstPage() {
        resetPagination()
        reload()
    }

    function reloadWithDebounce() {
        if (reloadDebounceTimer) {
            $timeout.cancel(reloadDebounceTimer);
        }
        reloadDebounceTimer = $timeout(reloadFromFirstPage, 1500);
    }

    function checkState(state) {
        if (state === "N/A") return false;
        return true;
    }

    function resetPagination(){
        vm.query.page = 1;
    }

    function reload() {
        let [startTs, endTs] = getTimeFrame();
        let [sortOrder, sortField] = getSortOrder();
        vm.activityLogPromise = loadActivityLogs(vm.query.limit, (vm.query.page - 1), startTs, endTs, sortOrder, sortField);
        if (vm.activityLogPromise) {
            vm.activityLogPromise.then(
                (result) => {
                    if (!result.data) {
                        result.data = []
                    }
                    if (result.data.length > 0 || result.page === 0) {
                        vm.activityLogs.length = 0;
                        vm.rowsCount = 0;
                        vm.allActivityLogs = result.data;
                        vm.totalElements = getTotalElements(result);
                        updateActivityLogs();
                    } else {
                        revertPageInPaginator();
                    }
                },
                () => {
                    updateActivityLogs();
                }
            );
        }
    }

    function revertPageInPaginator() {
        vm.query.page--;
        vm.totalElements--;
    }

    // This is done to reuse the same table-pagination component for scrolling pagination
    function getTotalElements(result) {
        let totalElements = result.page * result.limit + result.data.length;
        if (result.data.length === result.limit) {
            totalElements++;
        }
        return totalElements;
    }

    function showStateDetails($event, title, state) {
        if (state) {
            var onShowingCallback = {
                onShowing: function () {
                }
            };
            $mdDialog.show({
                controller: 'ActivityLogStateController',
                controllerAs: 'vm',
                templateUrl: activityLogState,
                locals: {
                    title: title,
                    state: state,
                    showingCallback: onShowingCallback
                },
                parent: angular.element($document[0].body),
                targetEvent: $event,
                fullscreen: true,
                skipHide: true,
                onShowing: function (scope, event) {
                    onShowingCallback.onShowing(scope, event);
                }
            });
        }
    }

    function updateActivityLogs() {
        var result = $filter('orderBy')(vm.allActivityLogs, vm.query.order);
        if (vm.totalElements > vm.query.limit) {
            vm.rowsCount = vm.totalElements;
        } else {
            vm.rowsCount = result.length;
        }
        vm.activityLogs = result;
    }
}



// WEBPACK FOOTER //
// ./src/app/activity-log/activity-log.controller.js